import Cookies from "js-cookie";
import toast from "react-hot-toast";

const PUBLIC_PATHS = new Set(["/", "/login", "/forgot-password"]);

let redirecting = false;

export function isPublicAdminPath(pathname = "") {
  const path = String(pathname || "").toLowerCase().split("?")[0];
  return PUBLIC_PATHS.has(path);
}

/** Clear admin auth storage and send user to login (once per expiry burst). */
export function clearAdminSessionAndRedirect(message = "Your session has expired. Please log in again.") {
  if (typeof window === "undefined") return;
  if (redirecting) return;

  const path = window.location.pathname || "";
  if (isPublicAdminPath(path)) return;

  redirecting = true;

  try {
    localStorage.removeItem("token");
    localStorage.removeItem("naseebiAdmin");
    localStorage.removeItem("adminUserDetails");
    localStorage.removeItem("adminUserRole");
    localStorage.removeItem("supportTabPermissions");
    localStorage.removeItem("supportHasTeam");
  } catch {
    /* ignore */
  }

  Cookies.remove("token");
  Cookies.remove("naseebiadmin");

  if (message) {
    toast.error(message, { id: "admin-session-expired" });
  }

  window.location.replace("/login");
}

export function persistAdminSession(token, user) {
  if (!token) return;

  const clean = String(token).replace(/["',]/g, "");

  try {
    localStorage.setItem("token", clean);
    localStorage.setItem("naseebiAdmin", "true");
    if (user) {
      localStorage.setItem("adminUserDetails", JSON.stringify(user));
      const roleRaw = user.role ?? user.Role;
      if (roleRaw != null && String(roleRaw).trim() !== "") {
        localStorage.setItem("adminUserRole", String(roleRaw).trim());
      }
    }
  } catch {
    /* ignore */
  }

  Cookies.set("token", clean, { expires: 7 });
  Cookies.set("naseebiadmin", clean, { expires: 7 });
}
